import React from 'react';
import PropTypes from 'prop-types';
import { formatSignedCurrency, getWalletBalanceClass } from '../../config/utils';
import './companyWallet.css';

// Wallet balance shown as a link to the fund history when the user may view funds
const WalletBalanceCell = ({ balance, canView, loading, onClick }) => {
    const balanceClass = getWalletBalanceClass(balance);
    if (!canView) {
        return <span className={balanceClass}>{formatSignedCurrency(balance)}</span>;
    }
    return (
        <button
            type="button"
            className={`seller-modal sortBtn tableLink walletBalanceLink ${balanceClass}`}
            title="View fund history"
            disabled={loading}
            onClick={onClick}
        >
            {formatSignedCurrency(balance)}
        </button>
    );
};

WalletBalanceCell.propTypes = {
    balance: PropTypes.number,
    canView: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
};

export default WalletBalanceCell;
